export default __webpack_public_path__ + "static/media/DMSans-BoldItalic.0cb57cc0.ttf";